import axiosInstance from '../auth/axiosInstance';

export const getRoleList = async (page, pageSize) => {
  try {
    console.log('Fetching role list...');
    const { data: result } = await axiosInstance.post('/Role/GetRoles', null, {
      params: { pageNumber: page, pageSize },
    });

    console.log('role list response:', result);
    if (
      result.data &&
      Array.isArray(result.data.items) &&
      typeof result.data.totalCount === 'number'
    ) {
      const { items, totalCount, pageNumber, pageSize: returnedSize } = result.data;
      return { items, totalCount, pageNumber, pageSize: returnedSize };
    }

    console.error('Unexpected response structure:', result);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  } catch (error) {
    console.error('Error fetching roles:', error);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  }
};

export const addOrUpdateRole = async (roleData) => {
  try {
    console.log('Adding/updating region with data:', roleData);
    const formattedData = {
      ...roleData,
      isActive: roleData.isActive ? 1 : 0,
    };

    console.log('Formatted data being sent to API:', formattedData);
    const { data: responseData } = await axiosInstance.post(
      '/Role/AddOrUpdateRoles',
      formattedData
    );

    console.log('AddOrUpdateRole response:', responseData);
    if (responseData.data) {
      console.log('Returning role data:', responseData.data);
      return responseData.data;
    }

    console.error('Invalid response structure:', responseData);
    return {
      ...formattedData,
      id: formattedData.id || `temp-${Date.now()}`,
    };
  } catch (error) {
    console.error('Error during saving role:', error.message || error);
    throw error;
  }
};

export const deleteRole = async (roleId) => {
  const { data: responseData } = await axiosInstance.post(
    `/Role/DeleteRole/${roleId}`
  );

  const responseCode = responseData?.code ?? responseData?.Code;
  const failed =
    responseData?.data === false ||
    responseCode === 403 ||
    responseCode === 'Forbidden';

  if (failed) {
    const apiMessage = responseData?.message || responseData?.Message;
    throw new Error(apiMessage || 'Failed to delete role');
  }

  return responseData;
};
